import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import {useGetMcfxViqContacts} from '../../../../people-iq/graphql/hooks/use-get-mcfx-viq-contacts';

type Props = {
    entityId: string;
};

export function CellMatchedContacts(props: Props) {
    const {isLoading, mcfxViqContacts} = useGetMcfxViqContacts(props.entityId);
    const count = mcfxViqContacts ? mcfxViqContacts.length : undefined;
    const countText = count ? `${count} matched` : '';

    return (
        <div className='text-align-right'>
            {isLoading && !mcfxViqContacts ? <LoadingIcon size={7} /> : countText}
        </div>
    );
}
